import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Notification } from 'types';

const markNotificationRead = async (
  notificationId: string
): Promise<Notification> => {
  const { data } = await customAxios.patch<Notification>(
    `/notifications/${notificationId}/read`
  );
  return data;
};

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();

  return useMutation<Notification, Error, string>({
    mutationFn: markNotificationRead,
    onSuccess: (data) => {
      queryClient.setQueryData<Notification[]>(['notifications'], (old) => {
        if (!old) {
          return old;
        }
        return old.map((item) => (item._id === data._id ? data : item));
      });
    },
  });
};
